/* tslint:disable:max-line-length */
const NOT_REGEX_ERROR = 'Els caràcters "<" i ">" estan prohibits';

const messages = {
  common: {
    phoneInput: 'Número de telèfon',
  },
  cells: {
    cellSizeSmall: 'compartiment petit',
    cellSizeMedium: 'compartiment mitjà',
    cellSizeLarge: 'compartiment gran',
    unknown: '',
  },

  infoSaveMoney: {
    title: "Aconsegueix diners",
    text1: "Acumula 1 € per cada paquet rebut fins a un total de 10€.",
    text2: "Al tenir 10 € a la guardiola, Smart Point Girona es posarà en contacte amb tu per fer-te l'ingrés bancari.",
  },

  types: {
    crosstownRecipient: 'Enviar a un amic (destinatari)',
    crosstownSender: 'Enviar a un amic (remitent)',
    crosstown: "Enviar a un amic",
    clickCollect: "Click & collect",
    returns: "Retorna",
    external: 'Rebre paquets',
    publicDelivery: 'Rebre paquets',
    unknown: 'error',
    100: 'Envia a un amic',
    200: 'Rebre paquets',
    300: 'Click & Collect',
    400: 'Retorns',
  },

  status: {
    status: "Estat",
    waitingActionRecipient: "S'està esperant l'acció del destinatari",
    waitingActionSender: "S'està esperant l'acció del remitent",
    readyToPickUp: "Llest per recollir",
    waitingOrderDestination: "Destinació de la comanda en espera",
    inProgress: "Lliurament en curs",
    completed: "Completat",
    unknown: 'error',
    0: 'Descartat',
    90: 'Completat',
    10: 'Nou',
    20: 'Esperant el paquet',
    30: 'Esperant recollir',
    70: 'En lliurament',
    50: 'Processant',
    80: 'Entrega en el Smart point',
  },

  history: {
    title: "Historial",
  },

  statusCallToAction: {
    awaitingDropoffSender: "Col·loqueu el paquet al Smart Point per començar",
    awaitingPickupRecipient: "L'enviament està a punt, aneu al Smart Point",
    awaitingHubSelectionRecipient: "Per rebre l'enviament, seleccioneu una destinació",
  },

  dialogExternal: {
    title: "Rebre paquets",
    intro: "Rep els teus paquets gratis en menys de 24 hores, en punts de lliurament Zero Emissions repartits per tota la ciutat",
    list1: 'Quan compris en línia utilitza aquesta adreça d\'enviament',
    list2: 'Un cop arribi el paquet al nostre magatzem el portarem a l\'Smart Point que triïs',
    list2_2: 'Un cop arribi el paquet al nostre magatzem el portarem al teu Smart Point',
    list2Button: 'Tria Smart Point',
    list2ButtonAlt: 'Tria un altre Smart Point',
    list3: 'Rebràs un sms amb l\'enllaç per obrir el Smart Point quan el paquet estigui llest',
  },

  dialogNotAvailable: {
    title: "No disponible",
    text: "Actualment aquesta opció no està disponible",
  },

  serviceInterruption: {
    title: "Avís Important\n",
    text: "Per fer un pas endavant fem manteniment",
    text2: "INTERRUPCIÓ TEMPORAL DEL SERVEI DE LLIURAMENT GRATUÏT.",
    text3: "Rellançarem el servei amb noves funcionalitats ben aviat.",
  },

  dialogShipmentInfo: {
    orderNumber: "Número de comanda",
    createdAt: "Creat",
    type: "Tipus",
    sent: "Enviat",
    recipient: "Receptor",
    sender: "Remitent",
    status: "Estat",
    address: "Direcció",
    note: "Nota del remitent",
    selectOriginText: "per iniciar l'enviament, seleccioneu l'origen",
    selectOriginButton: "Seleccioneu origen",
    selectDestinationText: "Per rebre l'enviament, seleccioneu una destinació",
    selectDestinationButton: "Seleccioneu destinació",
    waitingRecipientText: "Esperant que el destinatari seleccioni una destinació",
    yourOrderInHubText: "El paquet està llest, aneu al Smart Point",
    openHub: "Obre Smart Point",
    selectHub: "Selecciona Smart Point",
    deliveringText: "Lliurament en procés",
  },

  dialogShipmentCancel: {
    title: 'Esborrar enviament',
    text: "No podràs desfer aquesta acció",
    delete: "Esborrar",
    cancel: "Cancelar",
  },

  dropupNotifications: {
    youHaveXNotif: "Tens {numNot} notificacions",
    youHave1Notif: "Tens 1 notificació",
    youHaveNoNotif: "No tens notificacions",
  },

  cards: {
    from: "de: {phone}",
    to: "a: {phone}",
    copied: "copiat",
    address: `Adreça`,
    selectDefaultDestination: "selecciona Smart Point per defecte",
    note: `Nota del remitent`,
    noteOwn: `Nota al destinatari`,
    toBeDelivered: `per lliurar`,
    deliveryInProgress: `lliurament en procés`,
    inLocker: `al Smart Point`,
    openHub: `OBRIR SMART POINT`,
    selectDestination: `Per a rebre l'enviament selecciona una destinació`,
    changeLocalization: `CAMBIAR LOCALIZACIÓ`,
    emptyActiveOrderList: `Res aquí<br/>Crea un nou enviament!`,
    selectDestinationHub: `SELECCIONA LA DESTINACIÓ`,
    awaitingDropoff: `Per començar l'enviament, deixa el paquet al Smart Point`,
    awaitingPickup: `Ja pots recollir el teu enviament en el Smart Point`,
    toBePickedUp: `Estem a l'espera que el destinatari reculli l'enviament`,
    sendAt: "Enviat a",
    // sendToAFriendOutgoing: `Envia a un amic`,
    sendToAFriendOutgoing: `Enviament a `,
    // sendToAFriendIncoming: `Enviament d'un amic`,
    sendToAFriendIncoming: `Enviament de `,
    externalIncoming: 'Tens un paquet',
    amazonReturns: " Devolució a Amazon",
    publicDelivery: 'Tens un paquet',
    clickCollectIncoming: 'Tens un paquet',
  },

  officeAddress: 'Centre {code}, {address}',

  selectDefaultDestination: {
    selectDefaultFooter: `Tria el teu Smart Point preferit. <br>Les teves compres arribaran a aquest Smart Point`,
    selectDefaultFooterSingleHub: `Aquest es el teu Smart Point. <br>Les teves compres arribaran aqui`,
    createDeliveryAddress: 'GENERAR DIRECCIÓ D\'ENTREGA',
    addressHelper: 'Has seleccionat l\'Smart Point ubicat a',
    selectOtherHub: 'SELECCIONA UN ALTRE SMART POINT',
    addressExplanation: 'COPIA I ENGANXA AQUESTA DIRECCIÓ A QUALSEVOL BOTIGA PER A REBRE ' +
      'LA TEVA COMANDA EN EL SMART POINT ESCOLLIT',
    smsWarning: 'T\'AVISAREM PER SMS',
    copyAddress: 'PREM PER COPIAR LA DIRECCIÓ',
    shippingNote: 'GENERA L\'ADREÇA I QUAN REBEM LA TEVA COMANDA LA PODRAS VEURE AQUI',
    shippingButton: 'GENERAR DIRECCIÓ D\'ENTREGA ',
  },

  buttons: {
    next: `SEGÜENT`,
    send: "ENVIAR",
    loadMore: `CARREGAR MES`,
    ok: `D'ACORD`,
    reopen: 'TORNAR A OBRIR',
    tryAgain: 'TORNAR A INTENTAR',
    cancel: `CANCEL·LAR`,
    done: `FET`,
    getStarted: `COMENÇAR`,
    finish: `ACABAR`,
    receiverPhone: `TELÈFON DEL RECEPTOR`,
    dropOffLocTime: `LOCALITZACIÓ DE LLIURAMENT`,
    confirm: `CONFIRMAR`,
    update: `Actualizació`,
    pressAndHold: "PREM<br/>I<br/>DEIXA",
    copied: "COPIAT",
  },

  haveYouOrder: {
    question: {
      text: `¿JA HAS FET LA TEVA COMANDA?`,
    },
    answer: {
      title: `¡GENIAL!`,
      text: `Rebràs un SMS amb més informació sobre la recollida i apareixerà aquí`,
    },
  },

  shipmentListTabs: {
    incoming: `Rebut`,
    outgoing: `Enviat`,
  },

  inputAndButtons: {
    search: `Cercar`,
    radioDontShow: `No tornar a mostrar els missatges d’ajuda aquí`,
  },

  // general errors
  errors: {
    validation: "No pots utilizar aquesta opció fins que facis la validació del teu número de teléfon",
    verification_code: 'Hi ha hagut un problema en la verificació. Estas segur que la URL es correcta?',
    required: 'Has d\'emplenar aquest camp',
    unknown: `Ups, ha passat alguna cosa inesperada.`,
    contact: "Si us plau, contacteu amb nosaltres",
    smsLimitReach: "Les nostres línies telefòniques estan ocupades, provi més tard o contacteu amb nosaltres",
    shipment_load_error: "Hi ha hagut un problema carregant aquest enviament",
    shipment_history_error: "Hi ha hagut un problema carregant el Hstòric",
    general: {
      string: `Mínim {0} caràcters`,
      required: `Aquest camp és obligatori.`,
      confirmed: `Les contrasenyes no coincideixen.`,
      email: `Si us plau introdueix un email vàlid.`,
      noCell: `Ho sentim, aquest hub no té cap compartiment disponible en aquest moment.`,
      cellWontOpen: `Uau! S'ha produït un error en intentar obrir el compartiment. Torna-ho a provar de nou o més tard.`,
      not_regex: NOT_REGEX_ERROR,
      validation: {
        phone: `Si us plau introdueix un número de telèfon vàlid.`,
      },
    },

  },

  // Options

  dropUp: {
    uniqueAddressLabel: `DIRECCIÓ DEL CENTRE D'ENVIAMENT`,
    uniqueAddressLabel2: `FES LA TEVA COMANDA ENGANXANT AQUESTA ADREÇA EXACTA PER REBRE EL PAQUET EN EL PUNT DE RECOLLIDA A SELECTIONAR`,
    selectOption: `SELECCIONA UNA OPCIÓ`,
    copied: `Copiat`,
    hubsButton: `VEURE TOTS ELS PUNTS DE RECOLLIDA`,
    crossTownDelivery: `ENVIAMENTS PER LA CIUTAT`,
    o: `o`,
    selectLockerSize: 'MIDA DE COMPARTIMENT',
  },

  drawer: {
    userMenu: {
      myProfile: `EL MEU PERFIL`,
      defaultHub: `EL MEU SMART POINT`,
      euroSaved: "ACUMULATS: ",
      ceo2Saved: "{co2} KG de Co2 estalviats",
      history: 'HISTORIAL',
      howItWorks: `COM FUNCIONA`,
      clickCollect: "CLICK&COLLECT PLUS",
      clickCollectLink: "https://smartpoint.city/click/",
      language: `IDIOMA`,
      signOut: `TANCA SESSIÓ`,
      crossTownDelivery: `ENVÍA A UN AMIC`,
    },
  },

  // pages

  home: {
    co2Saved: `CO2 ESTALVIAT`,
    validationMsg: "Aquest compte no ha estat validat. Algunes de les opcions no estaran disponibles.",

    buttons: {
      buttonExternal: 'REBRE PAQUETS',
      buttonClickCollect: 'CLICK & COLLECT',
      buttonClickCollectCi: 'EL CORTE INGLÉS C&C',
      buttonCrosstown: 'ENVIA A UN AMIC',
      buttonReturns: 'RETORNS',
    },
  },

  callUs: `PROBLEMES? TRUCA'NS`,

  shipmentNotes: {
    title1: `DEIXA UNA NOTA PER RECOLLIR`,
    placeholder: `Deixa una nota aquí...`,
  },

  crosstownLoading: {
    title: `UN MOMENT SI US PLAU`,
    comment: `Estem fent que funcioni`,
    finishText: `Hem reservat un <b>{hubSize}</b> a <b>{hubAddress}</b> on pots lliurar el teu paquet`,
    openHubBtn: `OBRIR EL HUB ARA`,
    goBackBtn: `FES-HO DESPRÉS`,
  },

  deliverySummary: {
    title: `RESUM DEL TEU LLIURAMENT`,
    phone: `Número de telèfon del destinatari`,
    dropoff: `Lliurar`,
    size: "Mida",
    deliveryLocation: `Lloc d’entrega`,
    weTakeCare: `No et preocupis, nosaltres ens en farem càrrec.`,
    payment: `Pagament`,
    note: `Nota`,
    confirmation: `Si us plan confirma que totes les dades anteriors són correctes`,
    phoneDisclaimer: "El receptor veurà el teu número de telèfon",
    // leaving here as reference
    errors: {
      sameUser: `No té sentit enviar-te un paquet a tu mateix`,
    },
  },

  registerOnboarding: {
/// ******
    onboarding1: {
      text1: `<b class="xl">Et donem la benvinguda a Smart Point Girona</b>`,
      text2: `Un sistema únic per rebre els teus paquets en punts intel·ligents repartits per tota la ciutat`,
    },

    onboarding2: {
      text1: ``,
      text2: `<b>Quan facis les teves compres online indica a la direcció d'entrega la ubicació de la nostra central` +
        ` logística</b>`,
    },

    onboarding3: {
      text1: '',
      text2: `<b>Una vegada rebem el teu paquet t'ho notificarem amb un missatge i et demanarem que escullis un` +
        ` Smart Point per recollir-lo</b>`,
    },

    onboarding4: {
      text1: ``,
      text2: `<b>Nosaltres ens encarreguem de deixar el teu paquet al Smart Point i t'avisarem quan estigui` +
        ` disponible</b>`,
    },
  },

  intro: {

    login: {
      title: `INICIAR SESSIÓ`,
    },

    register: {
      title: `REGISTRAR-SE`,
      registerUpText: `Introdueix les teves dades per registrar-te`,
      loginUpText: `Introdueix les teves dades per iniciar la sessió`,

      registerDownText: `Ja tens un perfil?`,
      registerLink: `Registrar-me`,

      loginDownText: `Encara no tens un compte?`,
      loginLink: `Iniciar sessió`,
    },

    done: {
      text1: `La seva adreça única de Smart Point Girona és`,
      text2: `Introdueix la teva adreça única com a destinació per a totes les teves comandes online`,
    },
  },

  sendReset: {
    text: "Introdueix el teu telèfon i et farem arribar un SMS des del que podràs accedir a l'enllaç de recuperació",
    back: "Tornar a l'inici de sessió",
    button: "Enviar",
    success: "Hem enviat un SMS al telèfon que ens has indicat",
  },

  reset: {
    title: "Canviar contrasenya",
    text: "Introdueix el teu correu electrònic i la nova contrasenya per poder canviar-la.",
    back: "Tornar a l'inici de sessió",
    password: "Nova contrasenya",
    button: "Canviar contrasenya",
    success: "La contrasenya ha estat canviada correctament",
    errors: {
      401: `Hi ha hagut un problema al canviar la contrasenya`,
    },
  },

  validationView: {
    title: "Validació d'usuari",
    text: "Espera un moment mentre validem el teu compte",
    back: "Tornar a l'inici de sessió",
    result: "El teu compte ha estat validat satisfactòriament",
    error: "Hi ha hagut un error al validar el teu compte",
    errors: {
      cantValidate: "El teu compte no ha pogut ser validat",
    },
  },


  registerForm: {
    namePlaceholder: `Nom...`,
    lastNamePlaceholder: `Cognoms...`,
    phonePlaceholder: `Número de telèfon...`,
    emailPlaceholder: `Email...`,
    passwordPlaceholder: `Contrassenya...`,
    passwordCreationPlaceholder: `Crea la teva contrassenya...`,
    rePasswordCreationPlaceholder: `Repeteix la teva contrassenya...`,
    resendVerificationText: "Semblas que ja estas registrat pero necesites validarte",
    resendVerificationButton: "Enviar enllaç de validació",
    resendVerificationSuccess: "Enllaç de validació ha sigut enviat via SMS",
    tos_text: 'Accepto els',
    tos_link_text: 'terminis i condicions d\'ús',

    errors: {
      409: `Sembla que ja estas registrat.`,
      no_regex: NOT_REGEX_ERROR,
    },
  },

  loginForm: {
    forgotPassword: `No recordo la contrasenya`,
    errors: {
      401: `Sembla que no et podem reconèixer. Potser has oblidat la teva contrasenya?`,
      not_regex: NOT_REGEX_ERROR,
    },
  },

  tos: {
    title: 'Termes i Condicions Smart Point City:',
    text: '<h4>Condicions Generals d’Entrega</h4>\n' +
        '<p>Aquestes dades són requerides per a la correcta gestió de la custòdia temporal i entrega de mercaderies i serveis, i les seves dades estan protegides en compliment del Reglament General de Protecció de Dades (RGPD) (UE) 2016/679 i de la Llei Orgànica 3/2018, de 5 de desembre, de Protecció de Dades de Caràcter Personal i Garantia dels Drets Digitals (LOPD i GDD), de protecció de dades de caràcter personal.</p>\n' +
        '<h4>Aspectes Generals</h4>\n' +
        "<p>El servei inclou la recollida, custòdia temporal i entrega de mercaderies i serveis, conforme al servei i terminis acordats, al terminal seleccionat dins de la xarxa de taquilles intel·ligents de Lava Locker S.L. sota la marca Smart Point i/o Mayordomo (d'ara endavant ‘Smart Point’ i/o ‘Mayordomo’).</p>" +
        '<h4>Servei d’entregues i recollides: Procés</h4>\n' +
        '<p>Tots els Usuaris tindran assignat un codi únic de lliurament, que els permet rebre lliuraments al Smart Point City. Per a cada entrega rebuda, l\'usuari rebrà un codi de recollida via email i SMS, sempre que el registre es completi amb un número mòbil vàlid, que necessitarà introduir a l\'aplicació web https://w.smartpoint.city/w/#/ , per a la retirada de la mercaderia de la taquilla dins del termini màxim de recollida, que és de 10 dies si no se n\'informa el contrari. És responsabilitat de l\'usuari la custòdia d\'aquest codi únic de lliurament i dels codis de recollida personals, i aquest pot cedir-los a un tercer per rebre o enviar un paquet. LAVA LOCKER, S.L. no es fa responsable de l\'ús del codi. <br> <br> Per a la modalitat de recepció de lliuraments les dimensions màximes que hauran de complir els enviaments per poder realitzar el lliurament a Smart Points, dependrà de la tipologia dels compartiments (de petit a gran): <br> <br> Petit: 40 cm ample x 7 cm alt x 50 cm fons <br> <br> Mitjà: 40 cm ample x 18 cm alt x 50 cm fons <br> <br> Gran: 40 cm ample x 29 cm alt x 50 cm fons <br> En cas de recepció de paquets amb mesures superiors, no podran ser lliurats als Smart Point. L\'usuari rebrà indicacions per a la recollida de paquets a l\'oficina de Smart Point sense cost, amb la següent excepció: per a paquets amb una mida superior als 75 centímetres en alguna de les seves dimensions, la custòdia per a la recollida a l\'oficina tindrà un cost de 1 € per cada 5kg de mercaderia a abonar per l\'usuari prèviament a la recollida. A més, Smart Point oferirà per a paquets amb mides superiors a les dimensions màximes l\'alternativa de lliurament a domicili, amb un cost associat. <br> Smart Point s\'eximeix davant l\'usuari de qualsevol responsabilitat quant al compliment dels terminis de lliurament compromesos per no disponibilitat de buits acords al tipus de mercaderia a lliurar a la taquilla seleccionada, sent responsabilitat del transportista que realitza el lliurament. Així mateix, no es responsabilitza de danys, tant en l\'embalatge com en contingut en la fase de transport en què altres operadors puguin haver incorregut. <br> Per a l\'ús dels serveis disponibles al Marketplace de Smart Point: l\'usuari haurà de realitzar la seva comanda a través de l\'aplicació https://w.smartpoint.city/w/#, deixant el/s article/s al compartiment corresponent quan calgui. Els preus dels serveis estan detallats a la informació de cada servei a l\'aplicació web. Els preus de cada servei es poden modificar sense notificació. Si no hi ha un preu especificat per a un servei i no es notifica altrament, com ara la necessitat de preparació d\'un pressupost, el servei és gratuït. Un cop realitzada una comanda, s\'enviarà una confirmació per email i SMS, a partir de la qual el preu no podrà ser modificat. L\'usuari també rebrà un enllaç o serà redirigit a la pàgina corresponent per pagar l\'import. Si la comanda requereix tornar algun article a l\'usuari, es lliuraran de nou al Smart Point.</p>\n' +
        '<h4>Custòdia temporal de paquets</h4>\n' +
        '<p>En donar-se d\'alta en aquest servei, l\'usuari autoritza LAVA LOCKER S.L. a la custòdia temporal d\'aquells paquets que es lliurin al Smart Point amb el codi de lliurament d\'usuari o com a part d\'un procés de comanda.</p>\n' +
        '<h4>Verificació de la naturalesa</h4>\n' +
        '<p>Smart Point es reserva el dret de verificar la naturalesa i el contingut dels paquets que li han estat confiats, incloent-hi la utilització de raigs X, així com interrompre tot procés de lliurament ja iniciat si aparegués un contingut que infringeixi les disposicions en vigor. Es reserva el dret de fotografiar els paquets que són dipositats a les taquilles intel·ligents per tal de demostrar el seu estat davant hipotètiques futures reclamacions; així com de realitzar els enregistraments dels seus terminals i les operacions a fi de garantir la correcta prestació del servei, la seva seguretat i utilització correcta.</p>\n' +
        '<h4>Mercaderia Exclosa</h4>\n' +
        '<p>Queda prohibit el dipòsit de paquets o objectes el contingut dels quals sigui contrari a la llei o l\'ordre públic, incorrent el client en les responsabilitats corresponents, i quedant LAVA LOCKER, S.L. totalment exonerada de les mateixes per aquesta causa. Queda prohibit el dipòsit d\'armes, rèpliques d\'armes, munició, articles robats, substàncies verinoses o infeccioses, diners en metàl·lic, pagarés, moneda, xecs, accions o participacions, or, plata en lingots, segells llevat de franquejats, mostres biològiques, restes humanes, joies, materials tòxics, drogues, animals i materials inflamables o perillosos. Smart Point no admetrà entregues amb servei contra reemborsament, aquells que tinguin necessitat de pagament de duanes o aquells que requereixin qualsevol pagament addicional. Finalment, tampoc no s\'admetran paquets de més de 50 kg.</p>\n' +
        '<h4>Política de devolució de l’import</h4>\n' +
        '<p>L\'usuari té dret a la devolució de l\'import de la seva comanda realitzada al Marketplace en cas que informe per correu electrònic a Smart Point del seu desig d\'una devolució, abans que el servei hagi estat realitzat. En cas contrari, no hi haurà devolució disponible. El client rebrà un correu electrònic de confirmació de l\'import del servei abans de començar la feina. Les cancel·lacions s\'han d\'informar per escrit, enviant un correu electrònic a hola@smartpoint.ai. No s\'acceptaran cancel·lacions informades per cap altra via.</p>\n' +
        '<h4>Política de cancel·lació</h4>\n' +
        '<p>Smart Point es reserva el dret a cancel·lar una comanda si no pot fer aquesta comanda. En cas que la comanda requereixi processar un ítem que l\'usuari hagués dipositat a l\'Smart Point, l\'ítem serà lliurat a la taquilla Smart Point corresponent sense haver estat processat i l\'usuari rebrà un email i SMS amb un codi d\'accés per recollir-lo.</p>\n' +
        '<h4>Dies i horaris de prestació de serveis</h4>\n' +
        '<p>Les taquilles Smart Point ofereixen un servei de lliurament vint-i-quatre (24) hores, els set (7) dies de la setmana. Aquest horari pot patir alteracions en funció de l\'accessibilitat i/o obertura del recinte en què es troba ubicat el terminal Smart Point, així com per causes alienes a Smart Point com fossin fallades en la cobertura de xarxes mòbils o elèctriques, quedant la prestació del servei de lliurament supeditat a aquestes.</p>\n' +
        '<h4>Formes de pagament</h4>\n' +
        '<p>Els pagaments pels serveis prestats es poden fer amb qualsevol tipus de targeta de crèdit o dèbit, sempre que aquesta sigui acceptada pel proveïdor de mètodes de pagament de Smart Point. Smart Point no té accés ni emmagatzema dades sensibles relatives al mitjà de pagament utilitzat per l\'Usuari/Client. Únicament l\'entitat corresponent processadora del pagament (proveïdor de mètodes de pagament) té accés a aquestes dades com a gestió dels pagaments i cobraments. Els pagaments seran capturats al moment en què l\'usuari entri a la pàgina web per verificar el pagament pendent o automàticament en el cas que les dades hagin estat guardades amb anterioritat amb l\'entitat processadora del pagament.</p>\n' +
        '<h4>Danys conseqüencials i lucre cessant</h4>\n' +
        '<p>LAVA LOCKER, S.L. o l\'empresa arrendatària del terminal no seran responsables per danys conseqüencials o extraordinaris, ni per lucre cessant, incloent-hi pèrdua d\'ingressos, beneficis o mercats, pèrdua d\'imatge, danys produïts per la impossibilitat d\'utilització dels continguts als paquets, ni per pèrdua d’oportunitat de negoci o qualsevol altra pèrdua indirecta que es derivi de la pèrdua, dany, retard, lliurament incorrecte o falta de lliurament del paquet.</p>\n' +
        '<h4>Condicions de l\'assegurança</h4>\n' +
        '<p>Indemnització màxima per la pèrdua o avaria de les mercaderies transportades i custodiades: els límits d\'indemnització per pèrdues o avaries de les mercaderies transportades i/o custodiades són els següents, d\'acord amb l\'art. 57 LCTT: 1/3 de l\'IPREM diari per quilogram, fet que implica una indemnització màxima de 6,2767€/kg, exclusivament pel període que el paquet roman dins dels compartiments de l\'Smart Point. L\'assegurança s\'aplica exclusivament a mercaderies. Les expedicions de documentació són assegurables pel valor de la impressió i no pel valor de creació o realització. La indemnització de la mercaderia utilitzada, en cas de pèrdua total, ha de patir la depreciació corresponent al seu valor actual, i en el cas de trencament parcial de la mercaderia s\'ha d\'indicar el que disposa la taxació del desperfecte.</p>\n' +
        '<h4>Termini de reclamació</h4>\n' +
        '<p>Per a una correcta gestió en la tramitació de les assegurances, la reclamació de qualsevol dany o perjudici detectat en la mercaderia objecte de la magatzem de la mercaderia en una taquilla intel·ligent Mayordomo, haurà de realitzar per telèfon o correu electrònic (93.250 21 70 / hola @ lavalocker.es) en un termini màxim de set (7) dies, a comptar des del moment pactat per al lliurament.</p>\n' +
        '<h4>Protecció de Dades</h4>\n' +
        '<p>En compliment del que estableix el Reglament General de Protecció de Dades (RGPD) (UE) 2016/679 i la Llei Orgànica 3/2018, de 5 de desembre, de Protecció de Dades de Caràcter Personal i Garantia dels Drets Digitals ( LOPD i GDD) us informem que les dades facilitades per vostè, així com les generades per la prestació del servei per part de Smart Point als seus clients, seran incorporades a la base de dades de la companyia, per a la correcta gestió del lliurament i posterior informació de promocions realitzades. La legitimació serà sobre la base de l’execució d’un contracte, interès legítim i el compliment d’obligacions legals. Les dades seran conservades durant el temps necessari per a una prestació correcta del servei, així com durant els terminis establerts pel compliment d\'obligacions legals. A més, no es preveuen cessions de dades personals a tercers, llevat de les necessàries per a la correcta prestació del servei complint amb els deguts compromisos de confidencialitat amb cadascun dels nostres proveïdors o col·laboradors. Vostè pot exercitar els drets d’accés, rectificació, supressió o oblit, limitació, oposició, portabilitat. Per això podrà enviar un email a dpo@lavalocker.es, o bé dirigir un escrit a Lava Locker S.L., al Carrer Ramon Turró nº5 - 08005 - Barcelona, ​​adjuntant còpia del seu DNI. Així mateix, l\'interessat pot adreçar-se a l\'Autoritat de Control en matèria de Protecció de Dades competent (AEPD, a Espanya) per obtenir informació addicional o presentar una reclamació, així com també pot contactar amb el nostre Delegat de Protecció de dades (ExpertosLOPD S.L.), al Carrer Juan Flórez, 146, 15005, A Corunya o email: dpd@expertoslopd.es. Per a més informació, podeu consultar la política de privadesa del responsable a https://smartpoint.ai/politica-de-privacidad </p>\n' +
        '<h4>Ús de galetes</h4>\n' +
        '<p>http://mayordomo.io i http://smartpoint.ai podran utilitzar cookies durant la presentació del servei del lloc web. Aquestes cookies corresponen a petits fitxers de text que contenen informació i que els llocs web envien a l\'ordinador del Client/Usuari quan està navegant pels mateixos. En cas que les tecnologies emprades no siguin estrictament necessàries per al funcionament correcte del servei, aquestes no s\'executaran sense el consentiment previ de l\'Usuari.</p>\n' +
        '<h4>Propietat intel·lectual i industrial</h4>\n' +
        '<p>Tots els drets de propietat intel·lectual i industrial sobre la web, l\'aplicació web i els seus continguts, entre els quals s\'inclou la programació, el disseny, les aplicacions, els gràfics, els codis, text o imatges, les marques, noms comercials, signes distintius i altres elements presents pertanyen en exclusiva a LAVA LOCKER S.L. Qualsevol reproducció, distribució, comunicació pública (inclosa la posada a disposició), transformació o qualsevol altra forma d\'explotació, ni tan sols citant les fonts, queda prohibida, llevat que es compti amb el consentiment previ, exprés i per escrit de LAVA LOCKER S.L.</p>\n' +
        '<h4>Fulls de reclamació</h4>\n' +
        '<p>EXISTEIXEN FULLS DE RECLAMACIONS A DISPOSICIÓ DEL CONSUMIDOR (DECRET 1/2010 DE 14 de gener) als quals pot accedir a Ramon Turró 5, Barcelona 08005.</p>\n' +
        '<h4>Legislació aplicable</h4>\n' +
        '<p>Les condicions presents es governaran per la legislació espanyola vigent. L\'idioma utilitzat serà l\'Espanyol. <br>  A l\'esdeveniment d\'haver de recórrer als Tribunals per dirimir qualsevol disputa entre les parts, això es realitzarà davant de les Corts i Tribunals de la ciutat de Barcelona.</p>',
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
        // placeholder
  },

  sendResetForm: {
    forgotPassword: `No recordo la contrasenya`,
    errors: {
      401: `Sembla que no et podem reconèixer. Potser aquest no es el teu email?`,
    },
  },

  thankYou: {
    title: `GRÀCIES PER UTILITZAR SMART POINT GIRONA`,
    text: `Acabes de guardar`,
  },

  openHub: {
    title1: `OBRIR HUB`,
    title2: `EL HUB ESTÀ OBERT`,
    text1: `Per a obrir el teu hub manté premut aquest botó`,
    text2: `Si us plau recordeu tancar el hub`,
    help: "NO S'OBRE? TRUCA'NS",
    addressLabel: `la adreça del teu hub és`,
    addressLabel2: `has d'estar davant del hub abans d'obrir-lo`,
  },

  crossTownDelivery: {
    title: `Envía a un amic`,
    start: {
      title: `T’ajudem a contactar amb la gent important de la teva vida. Deixa el que vulguis al Smart Point i ` +
        `nosaltres ho portarem a la persona que ens indiquis.`,
      text2_li_1: `Deixa-ho dins del Smart Point`,
      text2_li_2: `Indica el número de telèfon de la persona a qui vols enviar el paquet`,
      text2_li_3: `Nosaltres ens encarreguem de portar-ho on ens digui.`,
    },

    receiverPhone: {
      title: `TELÈFON DEL RECEPTOR`,
    },

    errors: {
      // put relevant errors here (same user etc) except global ones
      // look up errors in API ShipmentController
    },

  },

  amazonReturns: {
    title: 'Devolució a Amazon',
    start: {
      title: 'Oblida portar els paquets a una oficina o esperar al missatger:',
      text2_li_1: 'Deixa el teu paquet al Smart Point, no has de posar-hi etiqueta.',
      text2_li_2: 'Rebràs un correu nostre demanant que ens reenviïs l’etiqueta de devolució d’Amazon per email.',
      text2_li_3: 'El tornem a Amazon per tu.',
    },
    notesLabel: 'Informació sobre la devolució',
    summary: {
      title: 'Resum de la teva devolució',
      cellSize: 'Mida del compartimen',
      address: "Direcció d'enviament",
      notes: 'Informació sobre la devolució',
    },
  },

  clickAndCollect: {
    title: 'Click & Collect',
    start: {
      title: "Anem a qualsevol botiga de Girona a buscar les teves compres.",
      text2_li_1: 'Compra a la botiga indicant que ho passaràs a buscar més tard',
      text2_li_2: 'Indica les dades de la comanda en la nostra aplicació',
      text2_li_3: 'Nosaltres anem a buscar-la per tu i la deixem al Smart Point que ens indiquis',
    },
    finish: 'Gràcies',
    finish2: 'La teva comanda està en marxa. Si el repartidor necessita més informació et trucarà o t’enviarà un correu.' +
      ' Un cop el paquet estigui al Smart, rebràs un SMS per a poder recollir-lo.',
    errors: {
      email_sent: `Hi ha hagut un problema enviant el email`,
    },
    typeSelector: {
      client: "Endavant",
      shop: "Sóc Comerç",
    },
    label: {
      clientName: 'Nom del client',
      shopName: 'Nom de la botiga',
      phoneNumber: 'Telèfon d\'usuari',
      shopAddress: 'Adreça de la Botiga',
      addressToPickUp: 'Adreça completa on ho hem de recollir',
      comments: 'Informació addicional per recollir la compra',
      smartpointDestination: 'Smart Point de destí:',
    },
    placeholder: {
      shopName: 'nom',
      phoneNumber: 'telefon',
      addressToPickUp: 'Adreça',
      comments: 'Numero de comanda, Data de recollida...',
      smartpointDestination: 'Selecciona el Smart Point de destí:',
    },
  },

  clickCollectCi: {
    title: "El Corte Inglés C&C",
    start: {
      title: "Et portem la teva compra de El Corte Inglés <em>GRATIS</em> al teu Smart Point:",
      text2_li_1: '<a href="https://www.elcorteingles.es/">Compra online</a> i indica que aniràs a buscar-la més tard',
      text2_li_2: '<a href="mailto:{officeEmail}">Envia\'ns</a> les dades de la comanda',
      text2_li_3: `Nosaltres anem a buscar-la per tu i la deixem al Smart Point que ens indiquis`,
    },

    explanation: {
      title: 'Com funciona?',
      li1: 'Fes la teva compra a la web de <a href="https://www.elcorteingles.es/">El Corte Inglés</a>, selecciona <b>RECOGIDA EN TIENDA / CLICK&CAR i indica la botiga de Girona.</b>',
      li2: 'Després de comprar, indica que ho passarà a buscar SMART POINT GIRONA (telèfon {officePhone})',
      li3: 'Remet el correu que rebràs de El Corte Inglés a <a href="mailto:{officeEmail}">{officeEmail}</a> indicant el teu codi d’usuari {code}',
      li4: 'Nosaltres anirem a buscar la teva compra i, un cop la tinguem, la deixarem al Smart Point que ens indiquis.',
    },

    label:  {
      userName: 'Nom',
      email: 'Email',
      shop: 'Botiga',
    },

    form: {
      title: 'SUMARI',
      li1: 'Quan apretis “enviar” et remetrem un correu electrónic amb les instruccions per a utilizar el servei.',
    },

    finish: {
      title: 'Gracies',
      text: `T’hem enviat un correu electrònic amb les instruccions per fer servir aquest servei.<br/><br/>Smart Point Girona<br/>tecnologia per una ciutat més verda<br/>`,
    },
  },

  profile: {
    title: `El meu perfil`,
    label: {
      first_name: `Nom`,
      last_name: `Cognoms`,
      email: `Email`,
      isVerified: 'El teu número de telèfon ha estat confirmat',
      isNotVerified: 'Estem esperant que confirmis el teu número de telèfon',
      language: `Idioma`,
      phone_number: `Número de telèfon`,
      delivery_code: `Codi d'enviament`,
      member_since: `Member des de`,
    },
    placeholder: {
      first_name: `Introdueix el teu nom`,
      last_name: `Introdueix el teu cognom`,
      email: `El teu email`,
      language: `Idioma`,
      phone_number: `Número de telèfon`,
      delivery_code: `Codi d'enviament`,
      member_since: `Membre des de`,
    },
    member_since_format: `DD MMMM, YYYY`,
    copyDeliveryCode: 'Copia el códi de lliurament',
    deliveryCodeCopied: 'El codi de lliurament ha estat copiat al porta-retalls',
  },

  maps: {
    altText: `Selecciona un Smart Point`,
    confirm: `CONFIRMAR`,
    back: `ENRERE`,
  },

  installApp : {
    button: "Instal·lar app",
  },

  // no relevant errors to show apart un sections above
  //  there global fallback ones anyway (errors.general.xxx)
  // leaving here as reference
  // selectDestination: {
  //   errors: {}
  // },

  depositItem: {
    errors: {
      ReopenTimeLimitReachedException: 'El temps permès per tornar a obrir ha acabat',
    },
  },

  pickupItem: {
    errors: {
      ReopenTimeLimitReachedException: 'El temps permès per tornar a obrir ha acabat',
    },
  },

  cancelOrder: {
    errors: {
      shipmentCantBeCancel: "Aquest enviament no pot ser esborrat",
    },
  },
  // initStore: {
  //   errors: {}
  // },

};

export default messages;
